import { MutationTree } from 'vuex';
import { VasState, Item, Payload } from '@/store/Vas/state';

const buildItem = (payload: Payload, count: number): Item => {
  return { id: payload.id, count: count };
};

const findIndex = (list: Item[], payload: Payload) => {
  return list.findIndex(v => {
    return v && v.id && v.id === payload.id;
  });
};

const mutations: MutationTree<VasState> = {
  update: (state, payload: Payload) => {
    const index = findIndex(state.vas, payload);
    state.vas.splice(index, 1, buildItem(payload, payload.count as number));
  },
};

export default mutations;
